import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import PrivateLayout from "layouts/privateLayout";
import axios from "axios";
import moment from "moment";

import { Box, Button, Divider, Typography } from "@mui/material";

import CounterAR from "pages/Homepage/counterAR";
import InvoiceTypeBarChart from "./barChart";
import InvClassPieChart from "./pieChart";
import StatusPieChart from "./statusPieChart";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import SimCardAlertIcon from "@mui/icons-material/SimCardAlert";
import WarningIcon from "@mui/icons-material/Warning";
import RestorePageIcon from "@mui/icons-material/RestorePage";
import { blue, grey, orange, red, yellow, green } from "@mui/material/colors";
import { toast } from "react-toastify";
import ErrorAlert from "helper/errorAlert";
import { useLocation } from 'react-router-dom';
import { useApiClient } from "context/ApiClientContext";

export default function Homepage() {
  const [statusTypeFilter, setStatusTypeFilter] = useState([]);
  const [irbStatusType, setIrbStatusType] = useState([]);
  const [filterSelected, setFilterSelected] = React.useState("daily");
  const companyId = localStorage.getItem("companyId");
  const [xLabels, setXLabels] = useState([]);
  const [rData, setRData] = useState([0, 0, 0, 0]);
  const [pData, setPData] = useState([0, 0, 0, 0]);
  const location = useLocation();
  const [statusData, setStatusData] = useState();

  const statusLabels = {
    open: "Open",
    error: 'Error',
    pending: "Pending",
    rejected: "Rejected",
    dispute: "Dispute",
    success: "Success",
  };

  const currentDate = moment.utc().startOf("day").toISOString();
  const tomorrow = moment(currentDate).add(1, "day").toISOString();
  
  const apiClient = useApiClient();

  //function number of status
  const fecthStatusFilter = async (newFilterSelected) => {
    setFilterSelected(newFilterSelected);

    let dataLink = `dailystatus`;
    let docType = `dailydoctype`;
    let xLabels = [];
    let rData = [];
    let pData = [];

    switch (newFilterSelected) {
      case "daily":
        dataLink = `dailystatus`;
        docType = `dailydoctype`;
        break;

      case "weekly":
        dataLink = `weeklystatus`;
        docType = `weeklydoctype`;
        break;

      case "monthly":
        dataLink = `monthlystatus`;
        docType = `monthlydoctype`;
        break;
      case "yearly":
        docType = `yearlydoctype`;
        dataLink = `yearlystatus`;
        break;
      default:
        dataLink = `customstatus?startdate=${currentDate}&endddate=${tomorrow}`;
        docType = `customdoctype?startdate=${currentDate}&endddate=${tomorrow}`;
    }

    try {
      const responseStatus = await axios.get(
        `${apiClient}/${companyId}/board/${dataLink}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: "application/json",
          },
        }
      );

      const newStatus = responseStatus.data
        .filter((item) => {
          const status = item?.status?.toLowerCase();
          return status === "open" || status === "error" || status === "pending" || status === "rejected" || status === "dispute";
        })
        .sort((a, b) => {
          const order = ["open", "error", "pending", "rejected", "dispute"];
          return order.indexOf(a.status.toLowerCase()) - order.indexOf(b.status.toLowerCase());
        })
        .map((item) => {
          let status = item?.status?.toLowerCase() || null;
          let color, icon, value;
          switch (status) {
            case "open":
              color = grey[500];
              icon = <HourglassEmptyIcon />;
              value = item.totalRow;
              break;
            case "error":
              color = orange[800];
              icon = <SimCardAlertIcon />;
              value = item.totalRow;
              break;
            case "pending":
              color = yellow[700];
              icon = <PendingActionsIcon />;
              value = item.totalRow;
              break;
            case "rejected":
              color = red[900];
              icon = <WarningIcon />;
              value = item.totalRow;
              break;
            case "dispute":
              color = blue[900];
              icon = <RestorePageIcon />;
              value = item.totalRow;
              break;
            default:
              color = grey[400];
              icon = <RestorePageIcon />;
              value = 0;
          }
          return {
            label: statusLabels[status],
            color,
            value: value,
            icon,
          };
        });


      const newIrbStatus = responseStatus.data
        .filter((item) => {
          const status = item?.status?.toLowerCase();
          return status === "rejected" || status === "success";
        })
        .map((item) => {
          let status = item?.status?.toLowerCase() || null;
          let color, value;
          switch (status) {
            case "rejected":
              value = item.totalRow;
              color = red[900];
              break;
            case "success":
              value = item.totalRow;
              color = green[500];
              break;
            default:
              value = 0;
              color = grey[500];
          }
          return {
            label: statusLabels[status],
            color,
            value: value
          };
        });

      setStatusTypeFilter(newStatus);
      setIrbStatusType(newIrbStatus);

      const responseDocType = await axios.get(
        `${apiClient}/${companyId}/board/${docType}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: "application/json",
          },
        }
      );

      const apiResponse = responseDocType?.data?.data || [];

      if (apiResponse.length > 0) {
        apiResponse.forEach((item) => {
          if (item.docSource === "AP") {
            pData.push(
              item.invoice,
              item.creditNote,
              item.debitNote,
              item.refundNote
            );
          } else {
            rData.push(
              item.invoice,
              item.creditNote,
              item.debitNote,
              item.refundNote
            );
          }
        });
      }

      setRData(rData);
      setPData(pData);

      xLabels = [
        "Invoice",
        "Credit Note",
        "Debit Note",
        "Refund Note",
      ];

      setXLabels(xLabels);
    } catch (error) {
      console.error("An error occurred:", error.response);
    }
  };

  useEffect(() => {
    // fetchDataList();
    fecthStatusFilter(filterSelected);
    handleSubmit(new Event('fetch')); // Initial status fetch when component mounts
  }, [location]);

  const sendNotification = async () => {
    try {
      const response = await axios.get(`${apiClient}/board/servicesbydbname?`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          Accept: "application/json",
        },
      }
      );
      return response;
    } catch (error) {
      toast.error(error, {
        position: "top-right",
      });
      ErrorAlert(error)
      return error;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await sendNotification();
      if (response.data) {
        // const newStatus = response.data[0].servicestatus;
        const newStatus = response.data;

        setStatusData(newStatus);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const statusColor = statusData === 'Running' ? 'green' : (statusData === 'Stopped' ? 'red' : '');


  return (
    <PrivateLayout>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography variant="h5" fontWeight="bold">
              Analytics Dashboard
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="p" fontWeight="bold">
                Status :
              </Typography>
              <Box
                ml={1}
                bgcolor={statusColor}
                borderRadius={1}
                display="inline-flex"
                alignItems="center"
                justifyContent="center"
                sx={{ padding: "6px 9px", marginRight: "9px" }}
              >
                <Typography variant="body1" color="white">
                  {statusData}
                </Typography>
              </Box>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                sx={{ my: 1, padding: "6px 9px", display: { xs: "none", md: "block" } }}
              >
                Check Service
              </Button>
            </Box>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              sx={{ my: 1, padding: "6px 9px", display: { xs: "block", md: "none" } }}
            >
              Check Service
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Divider />

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {/* {statusTypeFilter + 1} */}
            <CounterAR
              filterSelected={filterSelected}
              data={statusTypeFilter}
              callbackFetchDataList={fecthStatusFilter}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <InvClassPieChart data={statusTypeFilter} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <StatusPieChart data={irbStatusType} />
          </Grid>
          <Grid item xs={12}>
            {/* {rData} */}
            <InvoiceTypeBarChart
              rData={rData}
              pData={pData}
              xLabels={xLabels}
            />
          </Grid>
        </Grid>
      </Box>
    </PrivateLayout>
  );
}